import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ListMedicineAdministrationTypeResponse } from '../../responses/pharmacy/list-medicine-administration-type.response';

@Injectable({
  providedIn: 'root'
})
export class MedicineAdministrationTypeService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listMedicineAdministrationType(): Observable<ListMedicineAdministrationTypeResponse>{
    let uri = `MedicineAdministrationType/`;

    return this.httpClient.get<ListMedicineAdministrationTypeResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, this.addHeaderToken())
    .pipe(
      catchError(this.handleError)
    )
  }
}